var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10.5 10.5V1.5M10.5 10.5V19.5M10.5 10.5H19.5H1.5","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }